import { render, staticRenderFns } from "./ProductChain.vue?vue&type=template&id=918a6eaa&scoped=true&"
import script from "./ProductChain.vue?vue&type=script&lang=js&"
export * from "./ProductChain.vue?vue&type=script&lang=js&"
import style0 from "./ProductChain.vue?vue&type=style&index=0&id=918a6eaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918a6eaa",
  null
  
)

export default component.exports